<template>

        <form ref="form" @submit="submitCreateDireccion">

<!--            <div class="bp-form-group">-->
<!--                <div class="content-group">-->
<!--                    <div>-->
<!--                        <label for="nombre_direccion-input" class="form-label">Direccion nombre</label>-->
<!--                        <div class="content-input">-->
<!--                            <input id="nombre_direccion-input" type="text" :class="'form-element '+{ 'is-invalid': errors.nombre_direccion }" v-model="form.nombre_direccion" required>-->
<!--                            <div v-for="error in errors.nombre_direccion" class="invalid-feedback">-->
<!--                                {{ error }}-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->

            <div class="bp-form-group">
                <div class="content-group">
                    <div>
                        <label for="nombre-input" class="form-label">Nombre</label>
                        <div class="content-input">
                            <input id="nombre-input" type="text" :class="'form-element '+{ 'is-invalid': errors.nombre }" v-model="form.nombre" required>
                            <div v-for="error in errors.nombre" class="invalid-feedback">
                                {{ error }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="bp-form-group">
                <div class="content-group">
                    <div>
                        <label for="apellidos-input" class="form-label">Apellidos</label>
                        <div class="content-input">
                            <input id="apellidos-input" type="text" :class="'form-element '+{ 'is-invalid': errors.apellidos }" v-model="form.apellidos" required>
                            <div v-for="error in errors.apellidos" class="invalid-feedback">
                                {{ error }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="bp-form-group">
                <div class="content-group">
                    <div>
                        <label for="nombre_empresa-input" class="form-label">Empresa (opcional)</label>
                        <div class="content-input">
                            <input id="nombre_empresa-input" type="text" :class="'form-element '+{ 'is-invalid': errors.nombre_empresa }" v-model="form.nombre_empresa">
                            <div v-for="error in errors.nombre_empresa" class="invalid-feedback">
                                {{ error }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="bp-form-group">
                <div class="content-group">
                    <div>
                        <label for="nif-input" class="form-label">DNI/CIF</label>
                        <div class="content-input">
                            <input id="nif-input" type="text" :class="'form-element '+{ 'is-invalid': errors.nif }" v-model="form.nif" required>
                            <div v-for="error in errors.nif" class="invalid-feedback">
                                {{ error }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="bp-form-group">
                <div class="content-group">
                    <div>
                        <label for="direccion-input" class="form-label">Dirección</label>
                        <div class="content-input">
                            <input id="direccion-input" type="text" :class="'form-element '+{ 'is-invalid': errors.direccion }" v-model="form.direccion" required>
                            <div v-for="error in errors.direccion" class="invalid-feedback">
                                {{ error }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="bp-form-group">
                <div class="content-group">
                    <div>
                        <label for="observaciones-input" class="form-label">Más información (opcional)</label>
                        <div class="content-input">
                            <input id="observaciones-input" type="text" :class="'form-element '+{ 'is-invalid': errors.observaciones }" v-model="form.observaciones">
                            <div v-for="error in errors.observaciones" class="invalid-feedback">
                                {{ error }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="bp-form-group">
                <div class="content-group">
                    <div>
                        <label for="movil-input" class="form-label">Teléfono</label>
                        <div class="content-input">
                            <input id="movil-input" type="text" :class="'form-element '+{ 'is-invalid': errors.movil }" placeholder="Movil" v-model="form.movil" required>
                            <div v-for="error in errors.movil" class="invalid-feedback">
                                {{ error }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="bp-form-group">
                <div class="content-group">
                    <div>
                        <label for="cod_postal-input" class="form-label">Código postal</label>
                        <div class="content-input">
                            <input id="cod_postal-input" type="text" :class="'form-element '+{ 'is-invalid': errors.cod_postal }" v-model="form.cod_postal" required>
                            <div v-for="error in errors.cod_postal" class="invalid-feedback">
                                {{ error }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="bp-form-group">
                <div class="content-group">
                    <div>
                        <label for="poblacion_nombre-input" class="form-label">Población</label>
                        <div class="content-input">
                            <input id="poblacion_nombre-input" type="text" :class="'form-element '+{ 'is-invalid': errors.poblacion_nombre }" v-model="form.poblacion_nombre" required>
                            <div v-for="error in errors.poblacion_nombre" class="invalid-feedback">
                                {{ error }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="bp-form-group">
                <div class="content-group">
                    <div>
                        <label for="pais-input" class="form-label">Pais</label>
                        <div class="content-input">
                            <b-form-select id="pais-input" :class="'form-element '+{ 'is-invalid': errors.pais_id }" @change="loadProvincias($event)" v-model="form.pais_id">
                                <option value="" selected>-- Selecciona pais --</option>
                                <option v-for="pais in paises" :value="pais.id">{{ pais.nombre }}</option>
                            </b-form-select>
                            <div v-for="error in errors.pais_id" class="invalid-feedback">
                                {{ error }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="bp-form-group">
                <div class="content-group">
                    <div>
                        <label for="provincia-input" class="form-label">Provincia</label>
                        <div class="content-input">
                            <b-form-select id="provincia-input" :class="'form-element '+{ 'is-invalid': errors.provincia_id }" v-model="form.provincia_id">
                                <option value="" selected>-- Selecciona provincia --</option>
                                <option v-for="provincia in provincias" :value="provincia.id">{{ provincia.nombre }}</option>
                            </b-form-select>
                            <div v-for="error in errors.provincia_id" class="invalid-feedback">
                                {{ error }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="bp-form-group">
                <div class="content-group">
                    <div class="type-client-selection visual_ceck">
                        <div class="pb-3 recargoVisual">
                            <input type="checkbox" tabindex="0" :id="requiereReID" v-model="form.requiere_re" :class="'form-element '+{ 'is-invalid': errors.requiere_re }" >
                            <label class="text" :for="requiereReID">
                                Necesito 'Recargo de equivalencia' en la facturación del pedido.
                            </label>
                        </div>
                    </div>
                </div>
            </div>

            <div class="bp-form-group">
                <div class="content-group">
                    <div class="type-client-selection newsletter">
                        <div>
                            <input type="checkbox" tabindex="0" :id="predEnvioID" v-model="form.pred_envio" :class="'form-element '+{ 'is-invalid': errors.pred_envio }" >
                            <label class="text" :for="predEnvioID">
                                Seleccionar como direccion de envio predeterminada
                            </label>
                        </div>
                    </div>
                </div>
            </div>

            <div class="bp-form-group">
                <div class="content-group">
                    <div class="type-client-selection newsletter">
                        <div>
                            <input type="checkbox" tabindex="0" :id="predFacturacionID" v-model="form.pred_facturacion" :class="'form-element '+{ 'is-invalid': errors.pred_facturacion }" >
                            <label class="text" :for="predFacturacionID">
                                Seleccionar como direccion de facturación predeterminada
                            </label>
                        </div>
                    </div>
                </div>
            </div>

            <div class="bp-form-group">
                <button class="alter-btn-green" type="submit" data-testid="login_button">
                    <span>Guardar dirección</span>
                </button>
            </div>

        </form>

</template>

<script>
    export default {
        props: ["prefixid"],
        data() {
            return {
                paises: "",
                provincias: "",
                errors: "",
                form: {
                    nombre_direccion: '',
                    nombre: '',
                    apellidos: '',
                    nombre_empresa: '',
                    nif: '',
                    direccion: '',
                    cod_postal: '',
                    poblacion_nombre: '',
                    provincia_id: '',
                    pais_id: '',
                    movil: '',
                    observaciones: '',
                    requiere_re: false,
                    pred_facturacion: '',
                    pred_envio: ''
                },
            }
        },
        mounted() {
            this.loadPaises();
        },
        methods: {
            loadPaises: function () {
                axios.get(this.route('account.get.paises')).then(response => {
                    this.paises = response.data.paises;
                }).catch(e => {
                    console.log(e);
                });
            },
            loadProvincias: function (pais_id) {
                axios.post(this.route('account.get.provincias'),{
                    pais_id: pais_id
                }).then(response => {
                    this.provincias = response.data.provincias;
                }).catch(e => {
                    console.log(e);
                });
            },
            submitCreateDireccion(evt) {
                evt.preventDefault();
                axios.post('/account/direccion/store',this.form).then(response => {
                    this.$parent.$emit('loadInfo');
                    this.$parent.$emit('loadAddressClient');
                    Vue.toasted.show(response.data.info, {
                        type: "success",
                        duration: 3000
                    });
                }).catch(e => {
                    Vue.toasted.show('Ha habido un error!', {
                        type: "error",
                        duration: 3000
                    });
                    if (e.response.status === 422) {
                        console.log(e.response.status);
                        this.errors = e.response.data.errors;
                    }
                });
            },
        },
        computed: {
            predEnvioID : function () {
                return "pred_envio" + this.prefixid;
            },
            predFacturacionID: function () {
                return "pred_facturacion" + this.prefixid;
            },
            requiereReID: function () {
                return "requiere_re" + this.prefixid;
            }
        }
    }
</script>
